import React, {
  ChangeEvent,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Box, IconButton, Input, Popover, Stack, Typography } from "@mui/material";
import ConfigWrapper from "../widget/ConfigWrapper";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import colorPickerLogo from "../../../../../assets/image/png/color-picker-logo.png";
import { ColorResult, SketchPicker } from "react-color";
interface Props{
    values:any;
    name:string;
   setValues: React.Dispatch<React.SetStateAction<any>>;
}
const OrderTrackingConfigCustom=(props:Props)=>{
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [anchorTl, setAnchorTl] = useState<null | HTMLElement>(null);
  const handleTablePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
      setAnchorTl(event.currentTarget);
    };
     const handleClose = () => {
    setShowPicker(showPicker.map(() => false)); // Set all values to false
  };
      const handleDisplayTextBlur = (
        index: number,
        event: ChangeEvent<HTMLInputElement>
      ) => {
        const newText = event.target.value.trim().toLowerCase();
    
        // Find the duplicate index
        const duplicateIndex = displayText.findIndex(
          (item, i) => item.text.trim().toLowerCase() === newText && i !== index
        );
    
        if (duplicateIndex !== -1) {
          alert(
            `The text "${newText}" already exists. The new entry will be removed.`
          );
          const newDisplayText = [...displayText];
          newDisplayText[index].text = ""; // Clear the new (current) entry
          setDisplayText(newDisplayText);
        }
      };

        const handleColorChange = (color: ColorResult, index: number) => {
         
          const newDisplayText = [...displayText];
          newDisplayText[index].color = color.hex;
          setDisplayText(newDisplayText);
      
           const keyName = props.name;
            const updatedColor = [...props.values[keyName].value];
              updatedColor[index] = {
                ...updatedColor[index],
                color: color.hex,
              };
      
              props.setValues({
                ...props.values,
                [keyName]: {
                  ...props.values[keyName],
                  value: updatedColor,
                  isValueUpdated: true,
                  domainType: "order_configuration",
                },
              });
        };
  const handleDisplayTextChange = (
      index: number,
      event: ChangeEvent<HTMLInputElement>
    ) => {
      const newDisplayText = [...displayText];
      const newText = event.target.value; // Keep spaces as user types
  
      // Find the duplicate index
      const duplicateIndex = newDisplayText.findIndex(
        (item, i) =>
          item.text.trim().toLowerCase() === newText.trim().toLowerCase() &&
          i !== index
      );
  
      if (duplicateIndex !== -1) {
        alert(
          `The text "${newText.trim()}" already exists. The new entry will be removed.`
        );
        newDisplayText[index].text = ""; // Clear the new (current) entry
      } else {
        newDisplayText[index].text = newText; // Set the new text value if it's not a duplicate
        const keyName = event.target.name;
  
        const updatedLabel = [...props.values[keyName].value];
          updatedLabel[index] = {
            ...updatedLabel[index],
            label: event.target.value, // update the label only
          };
  
          props.setValues({
            ...props.values,
            [keyName]: {
              ...props.values[keyName],
              value: updatedLabel,
              isValueUpdated: true,
              domainType: "order_configuration",
            },
          });
                
  
      }
  
      setDisplayText(newDisplayText);
    };
  
  const [keyCodes, setKeyCodes] = useState([
      { key: "0" },
      { key: "1" },
      { key: "2" },
      { key: "3" },
      { key: "4" },
    ]);
    const [showPicker, setShowPicker] = useState<boolean[]>([
        false,
        false,
        false,
        false,
        false,
      ]);
      const pickerRef = useRef<HTMLDivElement | null>(null);
    // Handle Table Popover close
    const handleTablePopoverClose = () => {
      setAnchorTl(null);
    };
     const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        if (keyName === "orderTrackingDefaultRange") {
          const inputValue = parseInt(e.target.value, 10);
          if (isNaN(inputValue) || inputValue < 1 || inputValue > 30) {
            return;
          }
        }
        props.setValues({
          ...props.values,
          [keyName]: {
            ...props.values[keyName],
            value: parseInt(e.target.value, 10),
            isValueUpdated: true,
            domainType: "order_configuration",
          },
        });
        // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
        //   {
        //     ...values,
        //     [keyName]: {
        //       ...values[keyName],
        //       value: e.target.value,
        //       isValueUpdated: true,
        //       domainType: "order_configuration",
        //     },
        //   },
        //   orderConfig
        // );
        // setPlayGroundConfiguration(convertedVals);
      };
    
     const [displayText, setDisplayText] = useState([
        { text: "Pending", color: "#00B050" },
        { text: "Cancelled", color: "#FF0000" },
        { text: "Delivered", color: "#0070C0" },
        { text: "Out for Delivery", color: "#FFA500" },
        { text: "Invoiced", color: "#002060" },
      ]);
      const setOrderTrackingConfiguration = () => {
    const orderTrackingConfig = props.values?.orderTrackingStages?.value;
    setDisplayText([
      {
        text: "Pending",
        color: orderTrackingConfig?.[0]?.color ?? "#00B050",
      },
      {
        text: orderTrackingConfig?.[1]?.label ?? "",
        color: orderTrackingConfig?.[1]?.color ?? "",
      },
      {
        text: orderTrackingConfig?.[2]?.label ?? "",
        color: orderTrackingConfig?.[2]?.color ?? "",
      },
      {
        text: orderTrackingConfig?.[3]?.label ?? "",
        color: orderTrackingConfig?.[3]?.color ?? "",
      },
      {
        text: orderTrackingConfig?.[4]?.label ?? "",
        color: orderTrackingConfig?.[4]?.color ?? "",
      },
    ]);

  };
useEffect(()=>{
  setOrderTrackingConfiguration()
},[])
       const togglePicker = (index: number) => {
    const updatedShowPicker = [...showPicker];
    updatedShowPicker[index] = !updatedShowPicker[index];
    setShowPicker(updatedShowPicker);
  };

      const handleKeyCodeBlur = (
        index: number,
        event: ChangeEvent<HTMLInputElement>
      ) => {
        const newKey = event.target.value.trim().toLowerCase();
    
        // Find the duplicate index
        const duplicateIndex = keyCodes.findIndex(
          (item, i) => item.key.trim().toLowerCase() === newKey && i !== index
        );
    
        if (duplicateIndex !== -1) {
          alert(
            `The key "${newKey}" already exists. The new entry will be removed.`
          );
          const newKeyCodes = [...keyCodes];
          newKeyCodes[index].key = ""; // Clear the new (current) entry
          setKeyCodes(newKeyCodes);
        }
      };
      const handleKeyCodeChange = (
        index: number,
        event: ChangeEvent<HTMLInputElement>
      ) => {
        const newKeyCodes = [...keyCodes];
        const newKey = event.target.value; // Keep the spaces while user is typing
    
        // Find the duplicate index
        const duplicateIndex = newKeyCodes.findIndex(
          (item, i) =>
            item.key.trim().toLowerCase() === newKey.trim().toLowerCase() &&
            i !== index
        );
    
        if (duplicateIndex !== -1) {
          alert(
            `The key "${newKey.trim()}" already exists. The new entry will be removed.`
          );
          newKeyCodes[index].key = ""; // Clear the new (current) entry
        } else {
          newKeyCodes[index].key = newKey; // Set the new key value if it's not a duplicate
        }
    
        setKeyCodes(newKeyCodes);
      };
  const open = Boolean(anchorEl);
  const tableOpen = Boolean(anchorTl);
  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
    };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const labels = ["Label 1", "Label 2", "Label 3", "Label 4", "Label 5"];
    return (
        <>
           
                    <div>
                      <Typography color={"#606060"} marginTop={2}>
                        Add the order status you wish to display in the Order Tracking
                        Page:
                        <IconButton
                          size="small"
                          onClick={handlePopoverOpen}
                          style={{
                            position: "relative",
                            verticalAlign: "super", // Aligns it as superscript
                            fontSize: "0.75rem", // Reduces the size if you want
                            color: "rgb(34, 124, 157)",
                          }}
                        >
                          <InfoOutlinedIcon fontSize="small" />
                        </IconButton>
                      </Typography>
        
                      <Popover
                        id="mouse-over-popover-temp"
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handlePopoverClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "left",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        PaperProps={{
                          style: { padding: "10px", maxWidth: "300px" },
                        }}
                      >
                        <Typography variant="body2" color="textPrimary">
                          <strong>Label:</strong> Is a unique identifier for the
                          customer's system.
                          <br />
                          <strong>Key/Code:</strong> Code which is used for tracking the
                          order in the DMS.
                        </Typography>
                      </Popover>
                    </div>
                    <Stack>
                      <table className="custom-table">
                        <thead>
                          <tr>
                            <th>LABEL</th>
                            <th>KEY/CODE</th>
                            <th>TEXT TO BE DISPLAYED IN APP</th>
                            <th>LABEL BG COLOR</th>
                          </tr>
                        </thead>
                        <tbody>
                          {labels.map((label, index) => (
                            <tr key={index}>
                              <td>
                                {index !== 0 ? (
                                  label
                                ) : (
                                  <div
                                    className="label"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {label}
                                    <div style={{ color: "red" }}>*</div>{" "}
                                    <IconButton
                                      size="small"
                                      onClick={handleTablePopoverOpen}
                                      style={{
                                        position: "relative",
                                        // verticalAlign: "super", // Aligns it as superscript
                                        fontSize: "0.75rem", // Reduces the size if you want
                                        color: "rgb(34, 124, 157)",
                                      }}
                                    >
                                      <InfoOutlinedIcon fontSize="small" />
                                    </IconButton>
                                    <Popover
                                      id="mouse-over-popover-table"
                                      open={tableOpen}
                                      anchorEl={anchorTl}
                                      onClose={handleTablePopoverClose}
                                      anchorOrigin={{
                                        vertical: "bottom",
                                        horizontal: "left",
                                      }}
                                      transformOrigin={{
                                        vertical: "top",
                                        horizontal: "left",
                                      }}
                                      PaperProps={{
                                        style: { padding: "10px", maxWidth: "300px" },
                                      }}
                                    >
                                      <Typography variant="body2" color="textPrimary">
                                        This will be the default order status of all the
                                        placed orders. For other labels, fill different
                                        order status you wish to display in the app.
                                      </Typography>
                                    </Popover>
                                  </div>
                                )}
                              </td>
                              <td>
                                <input
                                  disabled={index === 0}
                                  type="text"
                                  value={keyCodes[index]?.key}
                                  onChange={(event) =>
                                    handleKeyCodeChange(index, event)
                                  }
                                  onBlur={(event) => handleKeyCodeBlur(index, event)}
                                  className="table-input"
                                />
                              </td>
                              <td>
                                <input
                                  disabled={index === 0}
                                  type="text"
                                  value={
                                    index === 0 ? "PENDING" : displayText[index]?.text
                                  }
                                  onChange={(event) => {
                                    handleDisplayTextChange(index, event);
                                  }
                                  }
                                  onBlur={(event) => 
                                    handleDisplayTextBlur(index, event)
                                  }
                                  className="table-input"
                                  name='orderTrackingStages'
                                />
                              </td>
                              <td>
                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="center"
                                >
                                  <Box
                                    flex="0.35"
                                    position="relative"
                                    border="1px solid #BCBCBC"
                                    borderRadius="4px"
                                    marginRight="10px"
                                    width={35}
                                    height={35}
                                    padding={0}
                                    sx={{
                                      backgroundImage: `url(${colorPickerLogo})`,
                                      backgroundSize: "cover",
                                      backgroundPosition: "center",
                                      backgroundRepeat: "no-repeat",
                                    }}
                                  >
                                    <IconButton
                                      onClick={() => togglePicker(index)}
                                      aria-label="toggle color picker"
                                      style={{
                                        width: 45,
                                        height: 45,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        padding: 0,
                                      }}
                                    ></IconButton>
                                    {showPicker[index] && (
                                      <Box ref={pickerRef}>
                                        <div className="color-picker-popover">
                                          <div
                                            className="color-picker-cover"
                                            onClick={handleClose}
                                          />
                                          <SketchPicker
                                            color={displayText[index]?.color}
                                            onChangeComplete={(color) => {
                                              handleColorChange(color, index);
                                            }}
                                            disableAlpha
                                            // Custom styles for the SketchPicker
                                            styles={{
                                              default: {
                                                picker: {
                                                  backgroundColor: "#fff", // Background color of the picker
                                                  border: "1px solid #BCBCBC", // Border color
                                                },
                                                saturation: {
                                                  boxShadow:
                                                    "0 0 0 1px rgba(0,0,0,0.1)", // Shadow around the color area
                                                },
                                                hue: {
                                                  height: "8px", // Height of the hue slider
                                                  borderRadius: "4px", // Border radius of the hue slider
                                                  border: "1px solid #227C9D", // Border color of the hue slider
                                                },
                                                alpha: {
                                                  height: "8px", // Height of the alpha slider
                                                  borderRadius: "4px", // Border radius of the alpha slider
                                                  border: "1px solid #227C9D", // Border color of the alpha slider
                                                },
                                              },
                                            }}
                                          />
                                        </div>
                                      </Box>
                                    )}
                                  </Box>
                                  <Box flex="1.5" display="flex" alignItems="center">
                                    <input
                                      type="text"
                                      style={{
                                        textDecoration: "none",
                                        backgroundColor: displayText[index]?.color, // Text color from displayText array
                                      }}
                                      disabled={true}
                                      value={
                                        index === 0
                                          ? "PENDING"
                                          : displayText[index]?.text
                                      }
                                      onChange={(event) => {}}
                                      className="table-input"
                                    />
                                  </Box>
                                </Box>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </Stack>
                    <Typography color={"#606060"} marginTop={2}>
                      What would be the default date range for orders to be visible (in
                      days)?{" "}
                    </Typography>
                    <Input
                      style={{ width: "50%", display: "flex" }}
                      value={props.values?.orderTrackingDefaultRange?.value}
                      type="number"
                      onChange={handleValueChange}
                      name="orderTrackingDefaultRange"
                    />
           
        </>
    )
}
export default OrderTrackingConfigCustom;